import angular from 'angular'
import component from './component'

export default angular
  .module('ellipsis.searchResults', [])
  .component('searchResults', component)
